"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentSavedPrompt = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var pages_common_1 = require("@qwilr/pages-common");
var styles = __importStar(require("./DocumentSavedPrompt.css"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var DocumentSavedPrompt = function (_a) {
    var onClose = _a.onClose;
    var getSpringboardUrl = (0, pages_common_1.useSpringboardContext)().getSpringboardUrl;
    return (react_1.default.createElement(kaleidoscope_1.Panel, { className: styles.panel },
        react_1.default.createElement(kaleidoscope_1.RainbowBar, null),
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.contentsContainer, gap: "m", padding: "xl", direction: "vertical", justify: "center", align: "center" },
            react_1.default.createElement("div", { className: styles.closeButton },
                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), onClick: onClose })),
            react_1.default.createElement("img", { className: styles.image, alt: "Page saved in Qwilr Springboard", src: "/Public/Assets/Images/springboard-saved.png" }),
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true }, "Document saved in Qwilr Springboard"),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "Sign in to Qwilr Springboard at any time to access your accepted pages"),
            react_1.default.createElement(kaleidoscope_1.Button, { href: function () { return getSpringboardUrl("accepted", pages_common_1.SpringboardAppOrigin.DocumentSavedNotification); } }, "View in Springboard"))));
};
exports.DocumentSavedPrompt = DocumentSavedPrompt;
